import { render, staticRenderFns } from "./AttestationVeracite.vue?vue&type=template&id=c508c812"
import script from "./AttestationVeracite.vue?vue&type=script&lang=js"
export * from "./AttestationVeracite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports